<template>
  <div class="pageContainer">
    <div class="contentContainer grow">
      <h1 class="h bold">{{ $t("bnpl:limit.intro.title.text") }}</h1>
      <USPCard
        size="large"
        :icon="$t('clock')"
        :title="$t('bnpl:limit.intro.card.title')"
        :description="$t('bnpl:limit.intro.card.description')"
      />
      <div class="stretch flex-column gap-12">
        <p class="bold">
          {{ $t("bnpl:limit.intro.main_advantages") }}
        </p>
        <Accordion icon="receipt">
          <template v-slot:header>
            <p class="bold has-text-size-13">
              {{ $t("bnpl:limit.security_tip1.title") }}
            </p>
          </template>
          <template v-slot:subtitle>
            <p class="has-text-size-12 has-text-grey">
              {{ $t("bnpl:limit.security_tip1.sub_title") }}
            </p>
          </template>
          <template v-slot:content>
            <p class="has-text-size-13">{{ $t("bnpl:limit.security_tip1.description") }}</p>
          </template>
        </Accordion>
        <Accordion icon="receipt">
          <template v-slot:header>
            <p class="bold has-text-size-13">
              {{ $t("bnpl:limit.security_tip2.title") }}
            </p>
          </template>
          <template v-slot:subtitle>
            <p class="has-text-size-12 has-text-grey">
              {{ $t("bnpl:limit.security_tip2.sub_title") }}
            </p>
          </template>
          <template v-slot:content>
            <p class="has-text-size-13">{{ $t("bnpl:limit.security_tip2.description") }}</p>
          </template>
        </Accordion>
        <Accordion icon="receipt">
          <template v-slot:header>
            <p class="bold has-text-size-13">
              {{ $t("bnpl:limit.security_tip3.title") }}
            </p>
          </template>
          <template v-slot:subtitle>
            <p class="has-text-size-12 has-text-grey">
              {{ $t("bnpl:limit.security_tip3.sub_title") }}
            </p>
          </template>
          <template v-slot:content>
            <p class="has-text-size-13">{{ $t("bnpl:limit.security_tip3.description") }}</p>
          </template>
        </Accordion>
      </div>
    </div>
    <div class="actionArea">
      <button
        class="linkButton linkButtonSuccess justify-self-start-desktop leftAction"
        @click="previousStep"
      >
        <font-awesome-icon :icon="['fas', 'arrow-left']" />{{
          $t("bnpl:cancel")
        }}
      </button>
      <button
        class="btn btnL rightAction"
        @click="nextStep"
      >
        {{ $t("bnpl:continue") }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useLimitStore } from "~~/stores/limit";

const limitStore = useLimitStore();

const nextStep = () => {
  limitStore.nextPosition();
};

function previousStep() {
  navigateTo({ name: "financier" });
}
</script>

<style scoped lang="scss">
</style>
